import { ChangeEvent } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Button from "../Button";
import styles from "./Pagination.module.css";
import useGetPagination from "hooks/useGetPagination";

type PaginationProps = {
  count: number;
  totalPages: number;
  first: boolean;
  last: boolean;
};

export default function Pagination({
  count,
  totalPages,
  first,
  last,
}: PaginationProps) {
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { page, pageSize, handleUpdatePage, handleUpdatePageSize } =
    useGetPagination();

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    handleUpdatePageSize(e.target.value);
    handleUpdatePage("1");
    setSearchParams(
      (searchParams) => {
        searchParams.set("pageSize", e.target.value);
        searchParams.set("page", "1");
        return searchParams;
      },
      { replace: true, state },
    );
  };

  function nextPage() {
    const next = +page === totalPages ? page : +page + 1;
    handleUpdatePage(next.toString());
    setSearchParams(
      (searchParams) => {
        searchParams.set("page", next.toString());
        return searchParams;
      },
      { replace: true, state },
    );
  }

  function prevPage() {
    const prev = +page === 1 ? page : +page - 1;
    handleUpdatePage(prev.toString());
    setSearchParams(
      (searchParams) => {
        searchParams.set("page", prev.toString());
        return searchParams;
      },
      { replace: true, state },
    );
  }

  // if (pageCount <= 1) return null;

  return (
    <div className={styles["pagination__container"]}>
      <div className={styles["rows__per__page__container"]}>
        <div>Rows per page:</div>
        <select onChange={handleChange} value={pageSize}>
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="25">25</option>
        </select>
      </div>
      <div data-testid="current-page">
        {(+page - 1) * +pageSize + 1}-
        {+page === totalPages ? count : +page * +pageSize} of {count}
      </div>
      <div className={styles["pagination__buttons__container"]}>
        <Button
          data-testid="prev-page-button"
          className={`${styles["pagination__button"]} ${first ? styles["pagination__button--disabled"] : ""}`}
          onClick={prevPage}
          disabled={first}
          type="button"
        >
          Prev
        </Button>
        <Button
          data-testid="next-page-button"
          className={`${styles["pagination__button"]} ${last ? styles["pagination__button--disabled"] : ""}`}
          onClick={nextPage}
          disabled={last}
          type="button"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
